var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Component } from "react";
import { emitUserInteractionEvent } from "../utils/tracking.js";
class ErrorBoundary extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      error: false
    });
  }
  static getDerivedStateFromError() {
    return { error: true };
  }
  componentDidCatch(error) {
    console.error(`[@zapier/marketing-site-layout] ${error}`);
    emitUserInteractionEvent({
      event_action: "error",
      custom_tracking_fields: {
        error,
        component: this.props.name
      }
    });
  }
  render() {
    return this.state.error ? this.props.renderFallback() : this.props.children;
  }
}
export {
  ErrorBoundary
};
